"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var http_1 = require("@angular/http");
var base_1 = require("@bhtp-client-api/base");
var jurisdictions_1 = require("./models/jurisdictions");
var BhtpJurisdictionsService = (function (_super) {
    __extends(BhtpJurisdictionsService, _super);
    function BhtpJurisdictionsService(http) {
        var _this = _super.call(this) || this;
        _this.http = http;
        _this.invalidPostalCodeErrorMessage = 'We didn\'t recognize this Postal Code. Please verify the Postal Code is correct.';
        _this.postalStateMismatchErrorMessage = 'This Postal Code does not match the traveler\'s state of residence. Please verify the Postal Code is correct.';
        return _this;
    }
    BhtpJurisdictionsService.prototype.searchResidenceByPostalCode = function (postalCode, defaultCountryIso2Code) {
        var iso2CountryCodeFilter = defaultCountryIso2Code || '';
        var path = this.getFullUrl("postalcodes/" + encodeURIComponent(postalCode) + "/cities?countryIso2=" + iso2CountryCodeFilter);
        var options = this.getStandardRequestOptions();
        return this.http.get(path, options)
            .map(function (response) {
            var wrapper = response.json();
            if (!wrapper || !wrapper.results || wrapper.results.length !== 1) {
                return { validState: jurisdictions_1.AddressValidState.Invalid };
            }
            var result = wrapper.results[0];
            var toReturn = new jurisdictions_1.AddressSearchResult(result.postalCode, result.stateOrProvinceIso2, result.city, result.countryIso2);
            toReturn.validState = jurisdictions_1.AddressValidState.Valid;
            return toReturn;
        })
            .catch(this.handleError);
    };
    return BhtpJurisdictionsService;
}(base_1.BhtpBaseService));
BhtpJurisdictionsService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], BhtpJurisdictionsService);
exports.BhtpJurisdictionsService = BhtpJurisdictionsService;
//# sourceMappingURL=D:/a/1/s/eligibility/src/jurisdictions.service.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/eligibility/src/jurisdictions.service.js